// 用于匹配字符串变量
export const STRING_VAR_REG = /^\${(.+)}$/
